module.exports = __webpack_public_path__ + "img/vpg.717dbc4.svg";